<template>
    <b-container class="mt-5 pb-5">

        <b-row class="mt-3 mb-5">
            <b-col>
                <b-link class="link" :to="{name: 'conference-details', params: {id}}"><i class="far fa-long-arrow-left mr-2"></i>Back to Conference Details</b-link>
            </b-col>
        </b-row>

        <div class="mb-5">
            <h3 class="text-success">{{session.title}}</h3>
            <div class="meta">Presented by <strong>{{session.presenter}}</strong></div>
            <date-range :start="session.start_at" :end="session.end_at" class="meta"></date-range>
        </div>

        <b-nav class="reg-nav mb-5">
            <b-nav-item exact-active-class="active" :to="{name: 'sess-info'}"><i class="far fa-users mr-2"></i>Registrations</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'sess-surveys'}"><i class="far fa-poll-people mr-2"></i>Survey</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'sess-edit'}"><i class="far fa-pencil mr-2"></i>Edit</b-nav-item>
            <b-nav-item exact-active-class="active" :to="{name: 'sess-tools'}"><i class="far fa-cog mr-2"></i>Tools</b-nav-item>
        </b-nav>

        <router-view/>

    </b-container>
</template>

<script>
    import {mapActions} from "vuex";
    import DateRange from "../../../../components/DateRange";

    export default {
        name: "sess-details",
        components: {DateRange},
        props: ['sessId', 'id'],
        data: function () {
            return {
                session: {}
            }
        },
        methods: {
            ...mapActions(['getSessionById']),
        },
        mounted: function () {
            this.getSessionById(this.sessId).then(response => {
                this.session = response;
            })
        }
    }
</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    a.link {
        color: $success;
    }

    .reg-nav {
        .nav-item {
            margin-right: 1.5rem;

            a {
                padding: 0.2rem;

                color: $success;
                font-size: 1.1rem;

                &.active {
                    border-bottom: 3px solid $success;
                }
            }
        }
    }

</style>
